<template>
  <v-card>
    <v-card-text class="py-1">
      <v-row>
        <v-col md="11" cols="10" class="mx-auto my-auto" align-self="center">
          <v-card flat v-for="pureEvent in selectedTripPoints" :key="pureEvent.id" class="pl-md-5 my-2">
            <span class="font-weight-bold">id:</span> {{ pureEvent.id }},
            <span class="font-weight-bold">datetime:</span> {{ datetimeFormatted(pureEvent, 'datetime') }},
            <span class="font-weight-bold">diff: </span> {{ eventDiff(pureEvent) }},
            <span class="font-weight-bold">speed: </span> {{ fieldValueFormatted(pureEvent, 'speed') }}
            {{ $vuetify.lang.t('$vuetify.map.travelStats.averageSpeed.postfix') }},
            <span class="font-weight-bold">location accuracy:</span> {{ fieldValueFormatted(pureEvent, 'locationAccuracy', true) }},
            <span class="font-weight-bold">satellite count:</span> {{ pureEvent.satelliteCount }}
          </v-card>
          <template v-if="selectedTripPoints.length === 2">
            <v-card flat class="my-0">
              <v-card-title>{{ $vuetify.lang.t('$vuetify.sqlHelperDialog.pureEventsOld') }}</v-card-title>
              <v-card-text class="my-0 py-0">
                <code ref="pureOldQuery">{{ pureOldCode }}</code>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="green"
                  text
                  @click="saveQuery(pureOldCode, 'pureOldQuery')">
                  <v-icon left>{{ copyIcon }}</v-icon>
                  {{ $vuetify.lang.t('$vuetify.map.textCopyPopup.copy') }}
                </v-btn>
              </v-card-actions>
            </v-card>
            <v-card flat>
              <v-card-title>{{ $vuetify.lang.t('$vuetify.sqlHelperDialog.pureEventsNew') }}</v-card-title>
              <v-card-text class="my-0">
                <code ref="pureNewQuery">{{ pureNewCode }}</code>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="green"
                  text
                  @click="saveQuery(pureNewCode, 'pureNewQuery')">
                  <v-icon left>{{ copyIcon }}</v-icon>
                  {{ $vuetify.lang.t('$vuetify.map.textCopyPopup.copy') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-col>
        <v-col class="text-right" md="1" cols="2">
          <tooltip-basic :text="'$vuetify.map.travelMap.purePointCard.clearAll'"
                         :icon="closeIcon"
                         :emit-state="`clear-all-pure-points`"
                         :small-icon="true"
                         @clear-all-pure-points="$emit('clear-all-pure-points')">
          </tooltip-basic>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { durationLocalized, travelDateLocalized, valueFormatted } from '@/utils/travels'
import { newPureEventsRange, oldPureEventsRange } from '@/utils/sqlHelper'
import { mdiClose, mdiContentCopy } from '@mdi/js'
import snackbarMixin from '@/mixins/snackbarMixin'
import TooltipBasic from '@/components/utils/tooltipBasic'

export default {
  name: 'purePointCard',
  components: { TooltipBasic },
  mixins: [snackbarMixin],
  props: {
    selectedTripPoints: Array,
    rawValues: Boolean,
    datetimestart: Number,
    userId: Number
  },
  data: () => ({
    copyIcon: mdiContentCopy,
    closeIcon: mdiClose
  }),
  computed: {
    pureOldCode () {
      return this.codeFormatted(oldPureEventsRange)
    },
    pureNewCode () {
      return this.codeFormatted(newPureEventsRange)
    }
  },
  methods: {
    datetimeFormatted (event, value) {
      return this.rawValues ? event[value] : travelDateLocalized(event[value])
    },
    eventDiff (event) {
      return this.rawValues ? `${event.datetimeDiff} ms` : durationLocalized(event.datetimeDiff)
    },
    fieldValueFormatted (event, field, needFloat = false) {
      return this.rawValues ? event[field] : valueFormatted(event[field], needFloat)
    },
    codeFormatted (func) {
      if (this.selectedTripPoints.length !== 2) {
        return ''
      } else {
        const events = [this.selectedTripPoints[0].datetime, this.selectedTripPoints[1].datetime].sort()
        return func(events[0], events[1], this.datetimestart, this.userId)
      }
    },
    saveQuery (text, domElement) {
      this.$copyText(text, this.$refs[domElement])
        .then((e) => {
          this.openSuccessSnackbar('$vuetify.map.textCopyPopup.success')
        })
        .catch((e) => {
          console.error(e)
          this.openFailureSnackbar('$vuetify.map.textCopyPopup.failure')
        })
    }
  }
}
</script>

<style scoped>

</style>
